//creazione del drawer della toc
import React from 'react';
// import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import  ButtonMenuToc from '../DrawerButton/ButtonMenuToc'
import TocComponent from '../TocComponent/TocComponent'
 import './TocDrawer.css'
import { connect } from 'react-redux';
import Tooltip from '@material-ui/core/Tooltip';

 function DrawerLeft(props) {
  
  // const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleDrawerClose = () => {
    
    setOpen(false);
    
    
  };
  return (
    <div className={"root"}>
      
      <ButtonMenuToc openMenu={setOpen} button={props.value.buttonStyle}></ButtonMenuToc>
      
      <Drawer
      transitionDuration={500}
        className={"drawer"}
        variant="persistent"
        anchor="left"
        open={open}
        classes={{
          paper: "drawerPaper",
        }}
      >       
        <TocComponent data={props.dataList.data} callback={handleDrawerClose.bind(this)} />   

      </Drawer>
    </div>
  );
}
const mapStateToProps = state => {
  return {
      dataList: state.dataList
  }
}
export default connect(mapStateToProps)(DrawerLeft)